import React, { useEffect } from 'react'
import { Box, Typography,IconButton } from '@mui/material'
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom'
import { BackArrowIcon } from '../../icons'
import SpecializationDetailsForm from '../../components/SpecializationDetails/SpecializationDetailsForm'
import { useSelector, useDispatch } from 'react-redux'
import { setFields, resetFields } from './reducer/specializationFormSlice'
import { fetchSpecialization, saveSpecialization, updateSpecializationStatus } from '../../api/specializationApi'
import { useNotification } from '../../hooks/useNotification'
import { updateStatus } from '../../api/adminApi'

const SpecializationDetails = ({ backUrl = '/specialization-listing-management' }) => {
    const fields = useSelector(state => state.specializationForm.fields)
    const specializationState = useSelector(state => state.specializationForm)
    const userAuth = useSelector(state=>state?.auth)
    const dispatch = useDispatch()
    const { showSuccessNotification, showErrorNotification } = useNotification()
    const { specializationId } = useParams()
    const location = useLocation();
    const navigate = useNavigate();
    const resolvedBackUrl = location.state?.backUrl || backUrl;
    const isReviewer = userAuth?.user?.roles.some(ele=>ele?.module==="reviewer" && ele?.allowed===1)

    const handleBack = (e) => {
        e.preventDefault();
        if (resolvedBackUrl === -1) {
            navigate(-1);
        } else if (typeof resolvedBackUrl === 'string') {
            navigate(resolvedBackUrl, { state: { backUrl: location?.pathname, activeTab: location?.state?.activeTab } });
        } else {
            navigate(-1);
        }
    };

    const loadSpecialization = async (id=specializationId) => {
        try {
            const updatedFields = await fetchSpecialization(id, fields,isReviewer)
            if (updatedFields) {
                dispatch(setFields(updatedFields))
            }
        } catch (err) {
            console.error('Error fetching specialization:', err)
        }
    }

    useEffect(() => {

        if (specializationId) {
            loadSpecialization()
        } else {
            dispatch(resetFields())
        }
    }, [specializationId, dispatch,isReviewer])


    const handleSpecializationSubmit = () => {
        saveSpecialization(specializationState.fields)
            .then(() => {
                showSuccessNotification('Specialization saved successfully')
            })
            .catch((err) => {
                showErrorNotification(err.message || 'Failed to save specialization')
            })
    }

    const handleSpecializationApproval = () => {
        const idField = specializationState.fields.find(f => f.id === '_id')
        const objectId = idField?.value
        if (!objectId) {
            showErrorNotification('Please save specialization first')
            return
        }

        updateStatus({ id: objectId, status: "pending", type: "specialization" })
            .then(() => {
                showSuccessNotification('Specialization sent for review successfully')
            })
            .catch((err) => {
                showErrorNotification(err.message || 'Failed to send for review')
            })
    }

    return (
        <Box sx={{ background: '#fff' }}>
            <div
                className="page-header"
                style={{
                    position: 'sticky',
                    top: '4.5rem',
                    zIndex: '999',
                    padding: '10px 15px',
                    borderBottom: '1px solid #E6E7E8',
                    background: '#fff',
                }}
            >
                <div className="row align-items-center">
                    <div className="col">
                        <Typography
                            sx={{
                                fontSize: '18px',
                                fontWeight: '600',
                                color: '#15243E',
                                display: 'flex',
                                alignItems: 'center',
                                gap: 1,
                            }}
                        >
                             <IconButton onClick={handleBack} size="small" aria-label="Back">
                                <BackArrowIcon />
                            </IconButton>
                            Specialization Details CRM Entry Form
                        </Typography>
                    </div>
                    <div className="col">
                        <Box display="flex" gap={2} sx={{ justifyContent: 'end' }}>
                            {/* <Button
                                sx={{
                                    border: '1px solid #15243E',
                                    minHeight: 'auto',
                                    padding: '4px 15px',
                                    color: '#15243E',
                                    background: '#fff',
                                    fontSize: '14px',
                                    textTransform: 'capitalize',
                                }}
                            >
                                Preview
                            </Button>
                            <Button
                                sx={{
                                    border: '1px solid #1075FF',
                                    minHeight: 'auto',
                                    padding: '4px 15px',
                                    color: '#1075FF',
                                    background: '#fff',
                                    fontSize: '14px',
                                    textTransform: 'capitalize',
                                }}
                                onClick={handleSpecializationSubmit}
                                disabled={isReadOnly}
                            >
                                Save Draft
                            </Button>
                            <Button
                                sx={{
                                    background: '#098B34',
                                    color: '#fff',
                                    minHeight: 'auto',
                                    padding: '4px 15px',
                                    fontSize: '14px',
                                    textTransform: 'capitalize',
                                }}
                                onClick={handleSpecializationSubmit}
                                disabled={isReadOnly}
                            >
                                Publish
                            </Button>
                            <Button
                                sx={{
                                    background: '#0463EF',
                                    color: '#fff',
                                    minHeight: 'auto',
                                    padding: '4px 15px',
                                    fontSize: '14px',
                                    textTransform: 'capitalize',
                                }}
                                onClick={handleSpecializationApproval}
                                disabled={isReadOnly}
                            >
                                Send for Approval
                            </Button> */}
                        </Box>
                    </div>
                </div>
            </div>

            <SpecializationDetailsForm
                key={isReviewer}
                fields={fields}
                setFields={updatedFields => dispatch(setFields(updatedFields))}
                fetchSpecialization={loadSpecialization}
                editMode={isReviewer}
            />
        </Box>
    )
}

export default SpecializationDetails
